import { render, staticRenderFns } from "./TopicCommentCard.vue?vue&type=template&id=504d55be&lang=pug"
import script from "./TopicCommentCard.vue?vue&type=script&lang=ts"
export * from "./TopicCommentCard.vue?vue&type=script&lang=ts"
import style0 from "./TopicCommentCard.vue?vue&type=style&index=0&id=504d55be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports